/* CFG: Make minus + remove work in Cart Drawer (safe separate file) */
(function () {
  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function drawerIsOpen(drawer) {
    return drawer && (drawer.classList.contains('active') || drawer.getAttribute('aria-hidden') === 'false');
  }

  function findItemKey(el) {
    // Try common data attributes used in Dawn-like markup
    const key =
      el.closest('[data-key]')?.getAttribute('data-key') ||
      el.closest('[data-cart-item-key]')?.getAttribute('data-cart-item-key') ||
      el.closest('[data-line-item-key]')?.getAttribute('data-line-item-key') ||
      el.closest('[data-item-key]')?.getAttribute('data-item-key');

    return key || null;
  }

  function findLine(el) {
    // Fallback: some themes use data-index / data-line
    const line =
      el.getAttribute('data-line') ||
      el.getAttribute('data-index') ||
      el.closest('[data-line]')?.getAttribute('data-line') ||
      el.closest('[data-index]')?.getAttribute('data-index');

    if (line && /^\d+$/.test(line)) return Number(line);
    return null;
  }

  function findQtyInput(el) {
    return (
      el.closest('.quantity')?.querySelector('input[name="updates[]"], input.quantity__input, input[type="number"]') ||
      el.closest('[class*="quantity"]')?.querySelector('input[type="number"]')
    );
  }

  async function changeItem(payload) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        ...payload,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    });
    if (!res.ok) throw new Error('cart/change failed');
    return res.json();
  }

  function rerenderDrawer(state) {
    const drawer = getDrawer();
    if (!drawer) return;

    // Dawn-style drawers expose renderContents(parsedState)
    if (typeof drawer.renderContents === 'function') {
      drawer.renderContents(state);
      return;
    }

    // Fallback (rare): reload
    window.location.reload();
  }

  document.addEventListener(
    'click',
    async (e) => {
      const drawer = getDrawer();
      if (!drawerIsOpen(drawer)) return;

      // Only handle clicks inside the open drawer
      if (!drawer.contains(e.target)) return;

      // Trash/remove targets
      const removeTarget =
        e.target.closest('cart-remove-button') ||
        e.target.closest('button[name="remove"]') ||
        e.target.closest('a[href*="quantity=0"]') ||
        e.target.closest('a[href*="/cart/change"]') ||
        e.target.closest('[data-action="remove"]');

      // Minus target
      const minusTarget =
        e.target.closest('button[name="minus"]') ||
        e.target.closest('.quantity__button[name="minus"]') ||
        e.target.closest('.quantity-button[name="minus"]');

      if (!removeTarget && !minusTarget) return;

      e.preventDefault();
      e.stopPropagation();

      try {
        // Prefer changing by line-item key (most reliable)
        const target = removeTarget || minusTarget;
        const key = findItemKey(target);
        const line = findLine(target);

        // Determine new quantity
        let newQty = 0;
        if (minusTarget) {
          const input = findQtyInput(minusTarget);
          const current = input ? Number(input.value || 1) : 1;
          newQty = Math.max(0, current - 1);
        }

        let state;
        if (key) {
          state = await changeItem({ id: key, quantity: newQty });
        } else if (line) {
          state = await changeItem({ line, quantity: newQty });
        } else {
          console.warn('CFG drawer fix: could not find item key or line for', target);
          return;
        }

        rerenderDrawer(state);
      } catch (err) {
        console.error('CFG drawer fix failed:', err);
      }
    },
    true
  );
})();
